import { render, staticRenderFns } from "./VFormItemArray.vue?vue&type=template&id=0abb738a&"
import script from "./VFormItemArray.vue?vue&type=script&lang=js&"
export * from "./VFormItemArray.vue?vue&type=script&lang=js&"
import style0 from "./VFormItemArray.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports